<template>
  <div>
    <h2 class="mb-5">{{ $t('contract.current_contract') }}</h2>
    <div class="container-contract active" v-if="filterContractsActive.length > 0">
      <div class="card-contract" v-for="(contract, index) of filterContractsActive" :key="'contract_' + index">
        <div class="card-contract-header">
          <div class="card-contract-header-left">
            <div>
                {{ $t('contract.contract_number_only') }}
                {{ contract.contractId || "-" }} 
                ({{ contract.stallType ? $t(`contact.stall_type.${contract.stallType}`) : '-' }})
            </div>
            <div>
              <v-chip class="ml-2 font-weight-normal grey--text" color="rgb(240,242,246)" small v-if="contract.isCancelled">
                <v-icon left>mdi-circle</v-icon>{{ $t('bill.cancel') }}
              </v-chip>
              <v-tooltip top v-else-if="getRenewInContracts && contract.objectId == getRenewInContracts.objectId">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-bind="attrs" v-on="on" class="ml-2 font-weight-normal" color="warning" small>
                    <v-icon left>mdi-circle</v-icon>{{ $t('customer.waiting_renew_agreement') }}
                  </v-chip>
                </template>
                <div v-if="contract.renewForMainContract">
                  <div> 
                    <span>
                      {{ $t('customer.effective_to_date') }} 
                      {{ contract.renewForMainContract.renewEffectiveDateFormat }}
                    </span>
                    <span> 
                      ({{ $t('in') }} 
                      {{ $moment(contract.renewForMainContract.renewEffectiveDate.iso).diff($moment(), 'days') || 0 }} 
                      {{ $t('day') }})
                    </span>
                  </div>
                </div>
              </v-tooltip>
              <v-chip class="ml-2 font-weight-normal" color="error" small v-else-if="contract.ageExpire < 0">
                <v-icon left>mdi-circle</v-icon>{{ $t('area.renter_end_date') }}
              </v-chip>
              <v-tooltip top v-else-if="contract.isActive && checkAreaContract(contract).isCheckIn">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-bind="attrs" v-on="on" class="ml-2 font-weight-normal" color="info" small>
                    <v-icon left>mdi-circle</v-icon>{{ $t('area.waiting_enter_stall') }}
                  </v-chip>
                </template>
                <div>
                  <div>
                    {{ $t('area.waiting_enter_stall') }} 
                    {{ checkAreaContract(contract).numberCheckIn || 0 }}
                    /{{ contract.areas ? contract.areas.length : 0 }} 
                    {{ $t('area.space') }}
                  </div>
                </div>
              </v-tooltip>
            </div>
          </div>
          <div class="card-contract-header-right">
            <template v-if="contract.alertAgeExpire && contract.ageExpire > 0 && !contract.renewForMainContract && !checkAreaContract(contract).isCheckIn && !contract.isCancelled">
              <div class="orange--text font-weight-normal"> 
                <v-icon left small color="orange" class="mr-0 icon-circle-dot">mdi-circle</v-icon>
                {{ $t('contract.contract_will_expired_in') }} {{ contract.ageExpire  }} {{ $t('day') }}</div>
            </template>
          </div>
        </div>
        <div class="card-contract-body">
          <div>
            {{ $t('contract.start_and_end_date_of_contract') }}: 
            {{ $moment(contract.startDate.iso).format('DD/MM/YYYY') || "-" }} - 
            {{ $moment(contract.endDate.iso).format('DD/MM/YYYY') || "-" }} 
            ({{ diffDays(contract) }} {{ $t('day') }})
          </div>
          <div v-if="contract.contractLog && contract.contractLog.length > 0">
            {{ $t('latest_history') }} : 
            <template v-if="contract.contractLog[0]?.type == 'renew'">
              <b>{{ $t('contract.renew_area_contract') }}</b> 
              {{ $t('contract.from_contract') }} 
              {{ contract.contractLog[0]?.oldContract?.contractId || "-" }}
            </template>
            <template v-else-if="contract?.contractLog?.[0]?.type == 'transfer'">
              <b>{{ $t('contract.transfer_area_contract') }}</b> 
              {{ $t('from') }} {{ fullName(contract?.contractLog?.[0]?.fromCustomer) }} 
              <b>{{ $t('go_to') }}</b>
              {{ fullName(contract?.contractLog?.[0]?.toCustomer) }}
            </template>
          </div>
        </div>
        <div class="card-contract-footer">
          <div><span class="font-weight-bold">{{ contract?.market?.name || "-" }}</span> 
          <span class="font-weight-normal">
            ({{ $t('area.space') }} {{ contract?.areas?.[0]?.name || "-" }})
          </span></div>
          <div>
            <v-btn 
              color="grey darken-4"
              dark
              elevation="0"
              rounded
              text
              @click="getContractById(contract.objectId)"
            >
              <v-icon left>mdi-eye</v-icon>
              {{ $t('detail') }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="isFoundContractActive && filterContractsActive.length == 0">
      <div class="nodata-txt bg-active"> {{ $t('noinfo') }}</div>
    </div>
    <div v-else>
      <div class="nodata-txt bg-active"> {{ $t('not_found_data') }}</div>
    </div>

    <h2 class="mb-5 mt-5">{{ $t('contract.close_contract') }}</h2>
    <div class="container-contract not-active mt-4" v-if="filterContractsNotActive.length > 0">
      <div class="card-contract" v-for="(contract, index) of filterContractsNotActive" :key="'contract_' + index">
        <div class="card-contract-header">
          <div class="card-contract-header-left">
            <div>
              {{ $t('contract.contract_number_only') }} 
              {{ contract.contractId || "-" }} 
              ({{ contract.stallType ? $t(`contact.stall_type.${contract.stallType}`) : '-' }})
            </div>
            <v-chip class="ml-2 font-weight-normal grey--text" color="rgb(240,242,246)" small v-if="contract.isCancelled">
              <v-icon left>mdi-circle</v-icon>{{ $t('bill.cancel') }}
            </v-chip>
          </div>
          <div class="card-contract-header-right" v-if="!contract.isCancelled">
            <template v-if="contract.closeContractStatus && !contract.renewAppeal">
              <img :src="require(`@/assets/icons/${contract.closeContractStatus.icon}`)" alt="contract" class="mr-2 icon-contract">
              {{contract.closeContractStatus.text}}
            </template>
            <template v-else-if="contract.renewAppeal">
              <img :src="require(`@/assets/icons/contract_renew.svg`)" alt="contract" class="mr-2 icon-contract">
              {{ $t('customer.renew_agreement') }}
            </template>
          </div>
        </div>
        <div class="card-contract-body">
          <div>
            {{ $t('contract.start_and_end_date_of_contract') }}: 
            {{ $moment(contract.startDate.iso).format('DD/MM/YYYY') || "-" }} - 
            {{ $moment(contract.endDate.iso).format('DD/MM/YYYY') || "-" }} 
            ({{ diffDays(contract) }} {{ $t('day') }})
          </div>
          <div v-if="contract.contractLog && contract.contractLog.length > 0">
            {{ $t('latest_history') }} : 
            <template v-if="contract?.contractLog?.[0]?.type == 'renew'">
              <b>{{ $t('contract.renew_area_contract') }}</b> 
              {{ $t('contract.from_contract') }} 
              {{ contract?.contractLog?.[0]?.oldContract?.contractId || "-" }}
            </template>
            <template v-else-if="contract?.contractLog?.[0]?.type == 'transfer'">
              <b>{{ $t('contract.transfer_area_contract') }}</b> 
              {{ $t('from') }} {{ fullName(contract?.contractLog?.[0]?.fromCustomer) }} 
              <b>{{ $t('go_to') }}</b>
              {{ fullName(contract?.contractLog?.[0]?.toCustomer) }}
            </template>
          </div>
        </div>
        <div class="card-contract-footer">
          <div><span class="font-weight-bold">{{ contract?.market?.name || "-" }}</span> 
          <span class="font-weight-normal">
            ({{ $t('area.space') }} {{ contract?.areas?.[0]?.name || "-" }})
          </span></div>
          <div>
            <v-btn color="grey darken-4" dark elevation="0" rounded text @click="getContractById(contract.objectId)">
              <v-icon left>mdi-eye</v-icon>
              {{ $t('detail') }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="isFoundContractNotActive && filterContractsNotActive.length == 0">
      <div class="nodata-txt bg-not-active"> {{ $t('noinfo') }}</div>
    </div>
    <div v-else>
      <div class="nodata-txt bg-not-active"> {{ $t('not_found_data') }}</div>
    </div>
    <v-snackbar v-model="isError" color="error">
      {{ $t('customer.error_load_rental_agreement') }} </v-snackbar>
    <ContractDetailDialog v-model="dialog" :contractId="objectId" :show-area="true" :projectId="projectId"
      :marketId="marketId" @reloadContract="loadContracts"></ContractDetailDialog>
  </div>
</template>

<script>
import ContractDetailDialog from "./ContractDetailDialog";
import { mapGetters, mapActions } from "vuex";
export default {
  components: { ContractDetailDialog },
  name: "CustomerContract",
  props: {
    projectId: String,
    marketId: String,
    search: String,
  },
  computed: {
    ...mapGetters({
      getRenewInContracts: "contract/getRenewInContracts",
      getContractsActive: "contract/getContractsActive",
      getContractsNotActive: "contract/getContractsNotActive",
    }),
    filterContractsActive(){
      if(this.search){
        return this.getContractsActive.filter(contract => {
          let searchString = contract.contractId + " " + contract?.market?.name + " " + contract?.areas?.[0]?.name + " " + contract?.customer?.fullName
          return searchString.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      return this.getContractsActive
    },
    filterContractsNotActive(){
      if(this.search){
        return this.getContractsNotActive.filter(contract => {
          let searchString = contract.contractId + " " + contract?.market?.name + " " + contract?.areas?.[0]?.name + " " + contract?.customer?.fullName
          return searchString.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      return this.getContractsNotActive
    }
  },
  data() {
    return {
      objectId: null,
      dialog: false,
      isLoading: false,
      isError: false,
    };
  },
  methods: {
    ...mapActions({
      getContractsByCustomer: "contract/getContractsByCustomer"
    }),
    async loadContracts() {
      try {
        this.isLoading = true;
        await this.getContractsByCustomer({
          customerId: this.$route.params.customerId,
          isFetchLog: true
        });
        this.isLoading = false;
      } catch (error) {
        console.error("Error loading contracts:", error);
        this.isLoading = false;
        this.isError = true;
      }
    },
    getContractById(contractId) {
      this.objectId = contractId;
      this.dialog = true;
    },
    checkAreaContract(contract) {
      let res = {
        isCheckIn: false, numberCheckIn: 0, diff: 0
      }
      for (const area of contract.areas) {
        if (area.contract && area.contract.objectId == contract.objectId)
          res.numberCheckIn++
      }
      res.isCheckIn = contract.areas && res.numberCheckIn != contract.areas.length
      res.diff = contract.areas ? contract.areas.length - res.numberCheckIn : 0
      return res
    },
    fromBy(data) {
    let res = "-";
    if (data) {
      res = `${data.firstName} ${data.lastName}`;
    }
    return res;
    },
    fullName(data) {
      let res = "-";
      if (data && data.type == "company") {
        res = `${data.companyName}`;
      } else if (data && data.type == "personal") {
        res = `${data.title} ${data.firstName} ${data.lastName}`;
      }
      return res;
    },
    diffDays(data) {
      if(data.endDate && data.startDate){
        let a = this.$moment(data.endDate.iso).endOf("day");
        let b = this.$moment(data.startDate.iso).startOf("day");
        a.add(1, "days");
        return a.diff(b, 'days')
      }
      return 0
    }
  },
};
</script>

<style lang="scss" scoped>
.contract-show {
  transition: all 0.2s;
  border-width: 1px !important;
  box-shadow: 10px 5px 0px 0px rgb(0 0 0 / 3%) !important;
  background: #fdfdfd !important;
}

.contract-show:hover {
  transform: translateY(-5px);
  box-shadow: 10px 10px 0px 0px rgb(0 0 0 / 3%) !important;
  border-width: 1px !important;
  border-color: #eee !important;
}

.container-contract {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  padding: 24px;
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
  &.active{
    background: #E8F5E9;
  }

  &.not-active{
    background: #EEEEEE;
    .card-contract{
      &-header,&-body{
        color : #A9A9A9;
      }
    }
  }
  .card-contract {
    background: #fff;
    border-radius: 5px;
    padding: 10px;
    box-shadow: 0px 12px 44px 0px rgba(0, 0, 0, 0.12);
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-left {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 700;
      }
      &-right {
        display: flex;
        align-items: center;
      }
    }
    &-body {
      color: #A9A9A9;
      font-size: 16px;
      min-height: 50px;
      margin-top: 10px;
    }
    &-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
.nodata-txt{
  text-align: center;
  font-size: 18px;
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.bg-active{
    background: #E8F5E9;
  }
  &.bg-not-active{
    background: #EEEEEE;
  }
}

.icon-contract{
  width: 23px;
  height: 23px;
}

.icon-circle-dot{
  font-size: 10px !important;
}
.font-weight-normal{
  font-weight: 500 !important;
}
.v-chip .v-icon{
  font-size: 10px !important;
}
</style>
